module.exports = __webpack_public_path__ + "img/glow-green.6b9be86b.svg";